import { registerServiceWorker } from "@/modules/serviceWorkerRegistration";
registerServiceWorker();
import Vue from "vue";
import router from "./router";
import "tailwindcss/base.css";
import "./styles/tailwind.scss";
import "./styles/main.scss";
import "vue-toastification/dist/index.css";
import App from "./App.vue";

import Default from "./layouts/default.layout.vue";
import NoNavigation from "./layouts/no-navigation.layout.vue";
import Toast from "vue-toastification";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBold,
  faItalic,
  faHeading,
  faListUl,
  faListOl,
  faUndo,
  faRedo,
  faRulerHorizontal,
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
  faAlignJustify,
  faImage,
  faLink,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faBold,
  faItalic,
  faHeading,
  faListUl,
  faListOl,
  faUndo,
  faRedo,
  faRulerHorizontal,
  faAlignLeft,
  faAlignRight,
  faAlignCenter,
  faAlignJustify,
  faImage,
  faLink,
  faEnvelope
);
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.use(Toast, { timeout: 5000 });

Vue.component("default-layout", Default);
Vue.component("no-navigation-layout", NoNavigation);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
